const RECIBO = 'RECIBO'
const LICENCIA_FUNCIONAMIENTO = 'LICENCIA_FUNCIONAMIENTO'
const FICHA_RUC = 'FICHA_RUC'
const OTRO = 'OTRO'

const __dictionary = {
  [RECIBO]: { id: RECIBO, nombre: 'Recibo' },
  [LICENCIA_FUNCIONAMIENTO]: { id: LICENCIA_FUNCIONAMIENTO, nombre: 'Licencia de Funcionamiento' },
  [FICHA_RUC]: { id: FICHA_RUC, nombre: 'Ficha RUC' },
  [OTRO]: { id: OTRO, nombre: 'Otro' }
}

const __array = [
  __dictionary[RECIBO],
  __dictionary[LICENCIA_FUNCIONAMIENTO],
  __dictionary[FICHA_RUC],
  __dictionary[OTRO]
]

export default Object.freeze({
  RECIBO,
  LICENCIA_FUNCIONAMIENTO,
  FICHA_RUC,
  OTRO,
  __dictionary,
  __array
})
